// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__X02md","active":"Loader_active__gNOMk","loading":"Loader_loading__Rb1OM"};